
import { NgModule } from '@angular/core';
import { Routes, RouterModule, Router, ActivatedRoute, ActivatedRouteSnapshot, RoutesRecognized } from '@angular/router';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { DefaultLayoutComponent } from './components/default-layout/default-layout.component';
import { TranslateResolve } from 'app/shared/resolver/translate-resolver';
import { CommonService } from 'app/shared/services/common.service';
import { Store } from '@ngrx/store';
import { AppState } from 'app/app-state.index';
import { RouletteComponent } from 'app/public/components/web-roulette/roulette/roulette.component';
import { RouletteSubscribtionComponent } from 'app/public/components/subscribtion/roulette-subscribtion/roulette-subscribtion.component';
import { PaymentCompleteComponent } from 'app/public/components/subscribtion/payment-complete/payment-complete.component';
import { MyRoulettesComponent } from './components/web-roulette/my-roulettes/my-roulettes.component';
import { ProfileComponent } from './components/web-roulette/profile/profile/profile.component';
import { LidsComponent } from './components/web-roulette/lids/lids/lids.component';
import { LidsMobileComponent } from './components/web-roulette/lids/lids-mobile/lids-mobile/lids-mobile.component';
import { AppResolutionType } from 'app/shared/common/appResolution';
import { ResolutionType } from 'app/shared/model/enums';
import { CouponRedemptionComponent } from './components/coupons/coupon-redemption/coupon-redemption.component';
import { CouponsComponent } from './components/coupons/coupons/coupons.component';
import { ProfilePaymentsComponent } from './components/web-roulette/profile/profile-payments/profile-payments.component';
import { PaymentsMobileComponent } from './components/web-roulette/profile/payments-mobile/payments-mobile/payments-mobile.component';
import { BusinessCouponsComponent } from './components/web-roulette/Business-Cupons/business-coupons/business-coupons.component';
import { BusinessManagementComponent } from './components/web-roulette/business-management/business-management.component';
import { CouponsMobileComponent } from './components/web-roulette/Business-Cupons/Business-Coupon-Mobile/coupons-mobile/coupons-mobile.component';
import { BusinessManagementMobileComponent } from './components/web-roulette/business-management/Business-managementMobile/business-management-mobile/business-management-mobile.component';
import { LidsManagmentComponent } from './components/web-roulette/Lids-managment/Lids-Managment/lids-managment.component';
import { LidsManagmentMobileComponent } from './components/web-roulette/Lids-managment/Lids-Managment-Mobile/lids-managment-mobile/lids-managment-mobile.component';
import { BusinessDetailsComponent } from './components/web-roulette/business-management/BusinessDetails/business-details/business-details.component';
import { EditBusinessComponent } from './components/web-roulette/business-management/BusinessDetails/edit-business/edit-business.component';
import { LidsForBusinessComponent } from './components/web-roulette/business-management/BusinessDetails/lids-for-business/lids-for-business.component';
import { SubscriptionsForBusinessComponent } from './components/web-roulette/business-management/BusinessDetails/subscriptions-for-business/subscriptions-for-business.component';
import { PaymentsForBusinessComponent } from './components/web-roulette/business-management/BusinessDetails/payments-for-business/payments-for-business.component';



const routes: Routes = [
  {
    path: '', component: DefaultLayoutComponent, resolve: { menuTranslations: TranslateResolve }
    , data: { translateKey: 'MENU' },
    children: [
      { path: 'redem', component: CouponsComponent },
      { path: 'my-roulettes', component: MyRoulettesComponent },
      { path: 'profile', component: ProfileComponent },
      { path: 'roulette', component: RouletteComponent },
      { path: 'roulette/:id', component: RouletteComponent },
      { path: 'roulette-subscribtion', component: RouletteSubscribtionComponent },
      { path: 'roulette-subscribtion/:rouletteId', component: RouletteSubscribtionComponent },
      // {path:'businessCoupons',component:BusinessCouponsComponent},
      // {path:'businessManagment',component:BusinessManagementComponent},
      {
        path: 'business-details/:id', component: BusinessDetailsComponent, children: [
          { path: '', redirectTo: 'details', pathMatch: 'full' }, 
          { path: 'details', component: EditBusinessComponent },
          { path: 'leads', component: LidsForBusinessComponent },
          { path: 'subscriptions', component: SubscriptionsForBusinessComponent },
          { path: 'payments', component: PaymentsForBusinessComponent },
        ]
      },
      { path: 'payment-success', component: PaymentCompleteComponent, data: { success: true } },
      { path: 'payment-failed', component: PaymentCompleteComponent, data: { success: false } }
    ]
  },

];
const desktopRoutes = [{ ...routes[0] }];
desktopRoutes[0].children = [
  ...routes[0].children,
  { path: 'leads', component: LidsComponent },
  { path: 'businessCoupons', component: BusinessCouponsComponent },
  { path: 'businessManagment', component: BusinessManagementComponent },
  { path: 'leadsManagment', component: LidsManagmentComponent }
];

const mobileRoutes = [{ ...routes[0] }];
mobileRoutes[0].children = [
  ...routes[0].children.filter(r => r.path !== 'businessCoupons'),
  { path: 'leads', component: LidsMobileComponent },
  { path: 'businessCoupons', component: CouponsMobileComponent },
  { path: 'businessManagment', component: BusinessManagementMobileComponent },
  { path: 'leadsManagment', component: LidsManagmentMobileComponent }

];
let currentRoutes = AppResolutionType == ResolutionType.Desktop ? desktopRoutes : mobileRoutes;



@NgModule({
  imports: [RouterModule.forChild(currentRoutes,)],
  exports: [RouterModule]
})
export class CoreRoutingModule {


  constructor(private _localizationService: LocalizationService, private route: ActivatedRoute, private router: Router, private commonService: CommonService
    , private store: Store<AppState>) {
  }
}
